<template>
	<blockquote class="px-3 py-2 flex items-start gap-4 rounded border-l-4 border-aareii-700 bg-aareii-300 dark:bg-aareii-900 text-aareii-700 dark:text-aareii-300 font-mono font-light text-sm">
		<i class="fa-solid fa-quote-left text-2xl"/>
		<slot/>
	</blockquote>
</template>
<script setup lang="ts"></script>